export function HintBadge({ code, label }: { code: string; label: string }) {
  return (
    <span
      data-hint-code={code}
      className="inline-flex items-center rounded-full bg-amber-50 px-3 py-1 text-sm font-medium text-amber-800 ring-1 ring-amber-200"
    >
      {label}
    </span>
  );
}
